import axios from "axios";
import config from "../config";

const dashboardService = {
    getSpokeRevenueMetrics: async () => {
        try {
            const response = await axios.get(`${config.API_BASE_URL}dashboard/spoke-revenue`, {
                headers: config.getHeaders(),
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching spoke revenue metrics:", error);
            throw error;
        }
    },
};

export default dashboardService;
